import Pass1 from "./pass_1";
import V2SelectorOnlyPass from "./pass_V2_only";
import Pass2 from "./pass_2";
import RankedInterventionSelectorPass from "./pass_ranked_intervention_selector";
import getConfigForLocale from "../../config/getConfigForLocale";

const passes = [
  Pass1,
  V2SelectorOnlyPass,
  Pass2,
  RankedInterventionSelectorPass,
];

function getPassesForLocale(locale) {
  const config = getConfigForLocale(locale);
  return {
    configId: config.configId,
    disabledInterventionTypes: config.disabledInterventionTypes,
    passes: passes.map((Pass) => new Pass(config)),
  };
}

export default getPassesForLocale;
